import { render, staticRenderFns } from "./PlantDataTab.vue?vue&type=template&id=a30c2822&scoped=true&"
import script from "./PlantDataTab.vue?vue&type=script&lang=ts&"
export * from "./PlantDataTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30c2822",
  null
  
)

export default component.exports